import React from "react";

import CurrentFlowStep from "../currentFlowStep";
import { ApplicationFlowPropType, ApplicationFlows } from "../types";
import ApplicationFlowProvider from "../applicationFlowContext";

export default function FirstAccountApplicationFlow({
  activeChapter,
  step,
  setStep,
  basicAccountApplication,
  cardApplication,
  signingProcess,
  triggerReload,
}: ApplicationFlowPropType): React.JSX.Element {
  return (
    <ApplicationFlowProvider
      flow={ApplicationFlows.FIRST_BAA}
      activeChapter={activeChapter}
      setStep={setStep}
    >
      <CurrentFlowStep
        flowType={ApplicationFlows.FIRST_BAA}
        step={step}
        setStep={setStep}
        basicAccountApplication={basicAccountApplication}
        cardApplication={cardApplication}
        signingProcess={signingProcess}
        triggerReload={triggerReload}
      />
    </ApplicationFlowProvider>
  );
}
